export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">关于红桃影院</h2>
          <p className="text-sm text-foreground-500">致力于打造最优质的免费追剧平台</p>
        </div>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed space-y-4">
            <p className="text-sm md:text-base">
              红桃影院成立于 2019 年，是国内领先的免费电视剧在线观看平台。我们始终秉持"让每个人都有好剧可追"
              的理念，汇聚海量国产剧全集与韩剧在线看资源，涵盖古装传奇、悬疑推理、都市情感等全品类内容。
            </p>
            <p className="text-sm md:text-base">
              平台每日同步更新最新电视剧与热播剧集，保证追剧用户第一时间看到想看的内容。
              红桃影院的视频技术团队持续优化播放体验，支持多端无缝切换，让高清流畅追剧成为日常。
            </p>
            <p className="text-sm md:text-base">
              截至目前，红桃影院已累计服务超过 800 万追剧用户，日均播放量突破千万次。
              我们感谢每一位用户的支持与信任，并将继续努力，为大家带来更多优质影视内容。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}